const HeaderText = {
  fontWeight: '700',
};

const styles = {
  HeaderText: HeaderText,
};
export default styles;
